import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const blogs = [
    {
        id: 1,
        title: 'Navigating the Future of Remote Work',
        category: 'Career Advice',
        image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1200&q=80',
        date: 'March 15, 2024',
        content: `
            <p className="mb-6">The landscape of work has undergone a seismic shift. Remote work, once a luxury, has become a standard for millions of professionals across the globe.</p>
            <h2 className="text-2xl font-bold text-dark mb-4">The Benefits of Flexibility</h2>
            <p className="mb-6">For employees, flexibility means better work-life balance, reduced commute times, and the ability to work from anywhere. For employers, it opens up a global talent pool that was previously inaccessible.</p>
            <blockquote className="border-l-4 border-primary pl-6 my-8 italic text-xl text-secondary">
                "The office is no longer a physical place you go to, but a digital space where you come together to collaborate and innovate."
            </blockquote>
            <h2 className="text-2xl font-bold text-dark mb-4">Overcoming Challenges</h2>
            <p className="mb-6">Despite the benefits, remote work brings its own set of challenges, including digital fatigue and the difficulty of maintaining company culture. Success requires intentional communication and the right technology stack.</p>
        `
    },
    {
        id: 2,
        title: 'Top Skills for Tech Recruitment in 2024',
        category: 'Hiring Trends',
        image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=1200&q=80',
        date: 'March 12, 2024',
        content: `
            <p className="mb-6">As we move deeper into 2024, the skills required for success in the tech industry are evolving rapidly.</p>
            <h2 className="text-2xl font-bold text-dark mb-4">Technical Proficiency</h2>
            <p className="mb-6">AI and Machine Learning knowledge are no longer niche; they are becoming foundational. Similarly, cybersecurity awareness is critical across all development roles.</p>
            <h2 className="text-2xl font-bold text-dark mb-4">The Power of Soft Skills</h2>
            <p className="mb-6">Interestingly, as technology becomes more automated, soft skills like critical thinking, emotional intelligence, and cross-functional leadership are becoming even more valued by recruiters.</p>
        `
    },
    {
        id: 3,
        title: 'Building Inclusive Workplace Cultures',
        category: 'Management',
        image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80',
        date: 'March 10, 2024',
        content: `
            <p className="mb-6">Diversity is a fact, but inclusion is an act. Creating a workplace where everyone feels they belong is critical for innovation and talent retention.</p>
            <h2 className="text-2xl font-bold text-dark mb-4">Strategic Inclusion</h2>
            <p className="mb-6">Inclusion must be woven into the fabric of the organization, from the recruitment process to leadership development.</p>
        `
    }
];

export default function BlogDetail() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        const found = blogs.find(b => b.id === parseInt(id));
        setBlog(found || blogs[0]);
        window.scrollTo(0, 0);
    }, [id]);

    if (!blog) return null;

    return (
        <div className="bg-white min-h-screen pt-20">
            <article className="max-w-4xl mx-auto px-4 py-20">
                <Link to="/discover" className="text-primary font-bold flex items-center gap-2 mb-10 hover:underline">
                    <i className="fas fa-arrow-left"></i> Back to Discover
                </Link>

                <div className="mb-12">
                    <span className="bg-blue-50 text-primary px-4 py-1 rounded-full text-sm font-bold mb-4 inline-block">
                        {blog.category}
                    </span>
                    <h1 className="text-4xl md:text-5xl font-bold text-secondary leading-tight mb-6">
                        {blog.title}
                    </h1>
                    <div className="flex items-center gap-4 text-gray-400">
                        <div className="w-12 h-12 rounded-full bg-light"></div>
                        <div>
                            <p className="text-dark font-bold">Konnectt Editorial</p>
                            <p className="text-sm">{blog.date} • 8 min read</p>
                        </div>
                    </div>
                </div>

                <img src={blog.image} alt={blog.title} className="w-full h-[400px] object-cover rounded-[40px] mb-12 shadow-lg" />

                <div className="prose prose-lg max-w-none text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: blog.content }}>
                </div>

                <div className="mt-20 pt-10 border-t border-gray-100 text-center">
                    <h4 className="text-2xl font-bold text-secondary mb-6">Ready to take the next step in your career?</h4>
                    <Link to="/jobs" className="px-10 py-4 bg-primary text-white font-bold rounded-full hover:bg-blue-600 transition-all shadow-lg shadow-primary/30 inline-block">
                        Browse Open Roles
                    </Link>
                </div>
            </article>
        </div>
    );
}
